import { render, staticRenderFns } from "./TarjetaPaciente.vue?vue&type=template&id=7bd0c9c1&"
import script from "./TarjetaPaciente.vue?vue&type=script&lang=js&"
export * from "./TarjetaPaciente.vue?vue&type=script&lang=js&"
import style0 from "./TarjetaPaciente.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports